import { useFifaProcessedCardImage } from "../../hooks/useFifaProcessedCardImage";

export type FifaCardPreviewVariant = "save" | "compare";

type FifaCardPreviewWithShimmerProps = {
  imageUrl: string | null | undefined;
  alt: string;
  variant?: FifaCardPreviewVariant;
};

const VARIANT_CLASS_NAMES: Record<
  FifaCardPreviewVariant,
  {
    wrap: string;
    media: string;
    shimmer: string;
    image: string;
  }
> = {
  save: {
    wrap: "saveFifaCardPreviewWrap",
    media: "saveFifaCardPreviewMedia",
    shimmer: "saveFifaCardPreviewShimmer",
    image: "saveFifaCardPreview",
  },
  compare: {
    wrap: "fifaCardComparePreviewWrap",
    media: "fifaCardComparePreviewMedia",
    shimmer: "fifaCardComparePreviewShimmer",
    image: "fifaCardComparePreview",
  },
};

const FifaCardPreviewWithShimmer = ({
  imageUrl,
  alt,
  variant = "save",
}: FifaCardPreviewWithShimmerProps) => {
  const classes = VARIANT_CLASS_NAMES[variant];
  const { displayUrl, showShimmer } = useFifaProcessedCardImage(imageUrl);

  return (
    <div className={`${classes.wrap} ${showShimmer ? "is-shimmer" : "is-loaded"}`}>
      <div className={classes.media}>
        <div className={classes.shimmer} aria-hidden={!showShimmer} />
        {displayUrl ? (
          <img
            src={displayUrl}
            alt={alt}
            className={`${classes.image} ${showShimmer ? "" : "is-visible"}`}
            draggable={false}
          />
        ) : null}
      </div>
    </div>
  );
};

export default FifaCardPreviewWithShimmer;
